'use strict';
const { createAddQueries } = require('../addQueries');
const {
  id,
  payerId,
  payeeId,
} = require('./commons');

module.exports = createAddQueries({
  returnModel: {
    name: 'payee',
  },
  finders: [
    id,
    payerId,
    payeeId,
  ],
  orderBy: [
    id,
    payerId,
    payeeId,
  ],
});
